import React, { useMemo, useState } from "react";

import {
  SettingsViewState,
  SettingsViewStateContainer,
  initialSettingsViewState,
} from "@is/contexts/ViewStateContext/SettingsViewState";
import { getStateValues } from "@is/utils";

import {
  ContentViewState,
  ContentViewStateContainer,
  contentViewStateMethods,
  initialContentViewState,
} from "./ContentViewState";
import {
  RegistrationViewState,
  RegistrationViewStateContainer,
  initialRegistrationViewState,
} from "./RegistrationViewState";

export type ViewStateContainer<T> = T & {
  updateViewState(value: Partial<T>): void;
};

export type ViewStateContextValue = {
  registration: RegistrationViewStateContainer;
  content: ContentViewStateContainer;
  settings: SettingsViewStateContainer;
};

export const ViewStateContext =
  React.createContext<ViewStateContextValue>(null);

type Props = {
  children?: React.ReactNode;
};

export const ViewStateProvider = (props: Props) => {
  const [registrationViewState, setRegistrationViewState] =
    useState<RegistrationViewState>(initialRegistrationViewState);

  const [contentViewState, setContentViewState] = useState<ContentViewState>(
    initialContentViewState
  );

  const [settingsViewState, setSettingsViewState] = useState<SettingsViewState>(
    initialSettingsViewState
  );

  const contextValue = useMemo(
    () => ({
      registration: getStateValues(
        registrationViewState,
        setRegistrationViewState
      ),
      content: getStateValues(
        contentViewState,
        setContentViewState,
        contentViewStateMethods
      ),
      settings: getStateValues(settingsViewState, setSettingsViewState),
    }),
    [contentViewState, registrationViewState, settingsViewState]
  );

  return <ViewStateContext.Provider value={contextValue} {...props} />;
};
